function convertHexAToRGBA(hex) {
  let r = 0;
  let g = 0;
  let b = 0;
  let a = 1;
  const isWithoutAlpha = hex.length === 4 || hex.length === 7;
  if (isWithoutAlpha) {
    if (hex.length === 4) {
      r = Number.parseInt(`0x${hex[1]}${hex[1]}`);
      g = Number.parseInt(`0x${hex[2]}${hex[2]}`);
      b = Number.parseInt(`0x${hex[3]}${hex[3]}`);
    }
    if (hex.length === 7) {
      r = Number.parseInt(`0x${hex[1]}${hex[2]}`);
      g = Number.parseInt(`0x${hex[3]}${hex[4]}`);
      b = Number.parseInt(`0x${hex[5]}${hex[6]}`);
    }
    return `rgb(${r},${g},${b})`;
  }
  if (hex.length === 5) {
    r = Number.parseInt(`0x${hex[1]}${hex[1]}`);
    g = Number.parseInt(`0x${hex[2]}${hex[2]}`);
    b = Number.parseInt(`0x${hex[3]}${hex[3]}`);
    a = Number.parseInt(`0x${hex[4]}${hex[4]}`);
  }
  if (hex.length === 9) {
    r = Number.parseInt(`0x${hex[1]}${hex[2]}`);
    g = Number.parseInt(`0x${hex[3]}${hex[4]}`);
    b = Number.parseInt(`0x${hex[5]}${hex[6]}`);
    a = Number.parseInt(`0x${hex[7]}${hex[8]}`);
  }
  a = Number.parseFloat((a / 255).toFixed(3));
  return `rgba(${r},${g},${b},${a})`;
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  convertHexAToRGBA
};
//# sourceMappingURL=convertHexAToRGBA.js.map
